<ng-container>
    <app-table
        tableKey="personVisitRecords"
        [gridData]="store.data.getWorks()"
        [columns]="columns"
        translatePrefix="person.dashboard."
        [hideCheckboxes]="!extendedWorkExportsEnabled"
        [showSearch]="true"
        [showColumnVisiblity]="true"
        [showExport]="true"
        (detailCallback)="detail($event)"
        [additionalFilter]="extraFilters()"
        [refreshCallback]="store.api.getWorks"
        [refreshCallbackFragment]="workGridItemFrag"
    >
        @if (extendedWorkExportsEnabled) {
            <ng-template pTemplate="link" let-item="item">
                <app-button
                    styleClass="tableIcon"
                    svgIcon="pdf"
                    [text]="true"
                    (clickEvent)="$event.stopPropagation(); printRecord(item)"
                ></app-button>
            </ng-template>
        }

        <ng-template pTemplate="visitLength" let-item="item">
            {{ item | workLength }}
        </ng-template>

    </app-table>
</ng-container>
